import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getToken } from "./utils/tokenStore";

import hr from "./locales/croatian.json";
import sl from "./locales/slovenian.json";
import en from "./locales/english.json";
import pl from "./locales/polish.json";
import ro from "./locales/romanian.json";
import bg from "./locales/bulgarian.json";
import hu from "./locales/hungarian.json";
import bs from "./locales/bosnian.json";
import md from "./locales/romanian_moldova.json";

const fetchUserLanguage = async () => {
  try {
    const userId = sessionStorage.getItem("userId");
    const query = userId ? `?user_id=${userId}` : "";
    const url = `${process.env.REACT_APP_BASE_API_URL}/language${query}`;
    const token = getToken();
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (response.ok) {
      const data = await response.json();
      return data.language;
    }
  } catch (error) {
    console.error("Failed to fetch user language:", error);
  }
  return "en"; // Default language
};

export const initializeI18n = async () => {
  const userLanguage = await fetchUserLanguage();

  i18n.use(initReactI18next).init({
    resources: {
      hr: { translation: hr },
      sl: { translation: sl },
      en: { translation: en },
      pl: { translation: pl },
      ro: { translation: ro },
      bg: { translation: bg },
      hu: { translation: hu },
      bs: { translation: bs },
      md: { translation: md },
    },
    lng: userLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

  return userLanguage;
};

export default i18n;
